'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INIT = 'INITIALIZABLE_RECUDER.INIT';

var initializeReducers = exports.initializeReducers = function initializeReducers() {
  return {
    type: INIT
  };
};

var enableInitializing = exports.enableInitializing = function enableInitializing(reducer) {
  return function (prevState, action) {
    var prev = action.type === INIT ? undefined : prevState;
    return reducer(prev, action);
  };
};